import axios from "axios";

const API_HOST = process.env.VUE_APP_API_HOST || "http://localhost:3000";

export { axios };
export function api(path) {
  return `${API_HOST}/api/${path}`.replace(/(?<!:)\/+/gim, "/");
}
